<mat-radio-group [(ngModel)]="selectedSchool">
    <mat-menu #schoolMenu="matMenu">
    <div mat-menu-item (click)="$event.stopPropagation()">
        School
    </div>
    @for (school of schoolFilterList; track school.Id) {
        <div
        mat-menu-item
        role="menuitemradio"
        (click)="selectedSchool = school">
        <mat-radio-button [value]="school">{{school.SchoolName}}</mat-radio-button>
        </div>
    }
    </mat-menu>
</mat-radio-group>
@if (getSchoolServiceStatus === ServiceStatus.loading && !schoolFilterList) {
    <mat-spinner [diameter]="24" style="margin-right: 10px;">
    </mat-spinner>
}

@if (schoolFilterList && schoolFilterList.length > 1) {
    <button type="button" class="btn btn-icon text-action-blue school-selector" style="padding: 0;"[matMenuTriggerFor]="schoolMenu" (click)="$event.stopPropagation()" >
    @if (isWebView && selectedSchool) {
        <i class="icon-school" [ngClass]="{'icon-action-blue': isWebView, 'icon-white': !isWebView}" style="width: 20px; height: 20px;"></i>
        <span [ngClass]="{'text-action-blue': isWebView, 'text-white': !isWebView}" >{{selectedSchool.SchoolName}}</span>
    }
    @if (!isWebView && selectedSchool) {
        <span class="mobile-school-badge">
          <i class="icon-school icon-header-blue" style="width: 16px; height: 16px;"></i>
          <div class="school-name">{{selectedSchool.SchoolName}}</div>
        </span>
    }
    <i class="icon-chevron-down" [ngClass]="{'icon-action-blue': isWebView, 'icon-white': !isWebView}" style="width: 12px; height: 12px; margin-right: 5px;"></i>
    </button>
}

@if (getSchoolServiceStatus === ServiceStatus.error) {
    <span class="text-danger" style="margin-left: 10px;">Error loading schools</span>
    <button type="button" class="btn btn-secondary" (click)="loadSchools()">Retry</button>
}